<div class="content">
  <ng-container *ngIf="!!arrangementArray?.length">
    <div class="content grid-auto-1">
      <!--Arranger-->
      <div class="content layout-auto-1" style="width: 22rem;">
        <div class="md-menu-break">{{selectKey === 'auID' ? 'Auftrag' : 'Vorgang'}} {{vorgOrAuNr}}</div>
        <!--Content View-->
        <div class="content" cdkDropList [cdkDropListData]="arrangementArray" id="arrangementArray"
             [cdkDropListConnectedTo]="['arrangementArray']"
             (cdkDropListDropped)="dropPage($event)">
          <ng-container *ngIf="arrangementArray.length; else arrayEmpty">
            <ng-container *ngFor="let obj of arrangementArray; index as i">
              <!--Testrender-->
              <div class="md3-card-on-surface"
                   cdkDrag
                   [cdkDragData]="obj"
                   [class.report-doc-arranger-selected-card]="selectedItem === obj"
                   (click)="selectItem(obj)"
                   style="padding: .5rem; width: 20rem; overflow: hidden; position: relative; margin: 0 .5rem .5rem .5rem; cursor: pointer; transition: all 0.2s ease;">
                <ng-container>
                  <div class="grid-auto-1">
                    <i class="fa-duotone fa-2x fa-eye" style="margin: 0 1.25rem; text-align: center; cursor: pointer" ></i>
                    <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                      <div class="list-metadata" style="margin-left: 0;">

                        <div [ngSwitch]="true" style="overflow: hidden; white-space: nowrap">
                          <div *ngSwitchCase="!!obj.cvID"  >{{ enmSrv.getEnumerationText('CalculationVersionStatus', obj.cvCalculationVersionStatus_enmIdent)}}</div>
                          <div *ngSwitchCase="!!obj.qverID">{{ enmSrv.getEnumerationText('QuestionnaireVersionStatus', obj.qverQuestionnaireVersionStatus_enmIdent)}}</div>
                          <div *ngSwitchCase="!!obj.pdID"  >{{ enmSrv.getEnumerationText('PhotoDocumentationStatus', obj.pdPhotoDocumentationStatus_enmIdent)}}</div>
                          <div *ngSwitchCase="!!obj.dokID" ></div>
                          <div *ngSwitchDefault            >{{getRessource('NoState')}}</div>
                        </div>
                      </div>
                      <div class="grid-1-auto">
                        <div class="list-metadata">
                          <div [ngSwitch]="true" style="overflow: hidden; white-space: nowrap">
                            <div *ngSwitchCase="!!obj.cvID"  >{{ obj.cvLCD  | excDate: 'Globals.DateTimeFormatShort'}}</div>
                            <div *ngSwitchCase="!!obj.qverID">{{ obj.qverLCD  | excDate: 'Globals.DateTimeFormatShort'}}</div>
                            <div *ngSwitchCase="!!obj.pdID"  >{{ obj.pdLCD  | excDate: 'Globals.DateTimeFormatShort'}}</div>
                            <div *ngSwitchCase="!!obj.dokID" >{{ obj.dokLCD  | excDate: 'Globals.DateTimeFormatShort'}}</div>
                            <div *ngSwitchDefault            >{{getRessource('NoDate')}}</div>
                          </div>
                          <div [ngSwitch]="true" style="overflow: hidden; white-space: nowrap">
                            <div *ngSwitchCase="!!obj.cvID"  >{{ obj.cvLCU }}</div>
                            <div *ngSwitchCase="!!obj.qverID">{{ obj.qverLCU }}</div>
                            <div *ngSwitchCase="!!obj.pdID"  >{{ obj.pdLCU }}</div>
                            <div *ngSwitchCase="!!obj.dokID" >{{ obj.dokLCU }}</div>
                            <div *ngSwitchDefault            >{{getRessource('NoUser')}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="span-2" style="margin: 1rem 0">
                        <div class="grid-1-auto">
                          <div [ngSwitch]="true" style="overflow: hidden; white-space: nowrap">
                            <strong *ngSwitchCase="!!obj.cvID"  >{{ obj.cvName }}</strong>
                            <strong *ngSwitchCase="!!obj.qverID">{{ obj.qverName }}</strong>
                            <strong *ngSwitchCase="!!obj.pdID"  >{{ obj.pdName }}</strong>
                            <strong *ngSwitchCase="!!obj.dokID" >{{ obj.dokName }}{{ obj.dokErw }}</strong>
                            <strong *ngSwitchDefault            >{{getRessource('NoName')}}</strong>
                          </div>
                          <div class="typo-right">
                            <!--                          Seitenzahl-->
                          </div>
                          <div [ngSwitch]="true" style="overflow: hidden; white-space: nowrap">
                            <span *ngSwitchCase="!!obj.cvID"  >{{getRessource('Calculation')}}</span>
                            <span *ngSwitchCase="!!obj.qverID">{{getRessource('Questionnaire')}}</span>
                            <span *ngSwitchCase="!!obj.pdID"  >{{getRessource('PhotoDoc')}}</span>
                            <span *ngSwitchCase="!!obj.dokID" >{{getRessource('Attachment')}}</span>
                            <span *ngSwitchDefault            >{{getRessource('NoType')}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="span-2 list-secondary-text">

                        <div [ngSwitch]="true" style="overflow: hidden; white-space: nowrap">
                          <div *ngSwitchCase="!!obj.cvID"  >{{ obj.cvDescription }}</div>
                          <div *ngSwitchCase="!!obj.qverID">{{ obj.qverDescription }}</div>
                          <div *ngSwitchCase="!!obj.pdID"  >{{ obj.pdDescription }}</div>
                          <div *ngSwitchCase="!!obj.dokID" >{{ obj.dokBeschreibung}}</div>
                          <div *ngSwitchDefault            >{{getRessource('MissingDate')}}</div>
                        </div>
                      </div>

                      <div class="span-2" style="display: flex; justify-content: flex-end; align-items: center; gap: 6px; margin-top: 0.5rem;font-size: 0.75em; color: var(--c-neutral-600);">
                        <i class="fa-regular fa-file-lines"></i>
                        <span >
                       {{getSelectedPagesText(obj)}} / {{getAvailablePages(obj)}}
                     </span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
          <!--Empty-->
          <ng-template #arrayEmpty>
            <div class="splash empty">
              {{getRessource('DataGhost')}}
            </div>
          </ng-template>

          <!--<button (click)="downloadReportDocPDF()" class="md-btn">
            Download
          </button>
          <button (click)="logArrangementArray()" class="md-btn">
            Log
          </button>-->
        </div>
      </div>
      <!--Preview-->
      <div class="content app-border-left layout-auto-1">
        <!--Header-->
        <div class="grid-1-auto">
          <div class="md-menu-break">
            <ng-container [ngSwitch]="true">
              <span *ngSwitchCase="!!selectedItem?.cvID">{{getRessource('SelectSheets')}}</span>
              <span *ngSwitchDefault>{{getRessource('SelectPages')}}</span>
            </ng-container>
          </div>
        </div>

        <!-- page selector Modal -->
        <div class="content" *ngIf="selectedItem && getAvailablePages(selectedItem) > 1; else noPages">
          <div class="modal-body content">
            <div class="layout-auto-1-auto">

              <div class="content layout-auto-1">
                <div class="content" *ngIf="selectedItem && getAvailablePages(selectedItem) > 1">
                  <div class="content">

                    <!-- PDF pages peview -->
                    <ng-container *ngIf="!isLoadingPreview && !isPhotoDocPreview && selectedItem.dokID && selectedItem.dokMIME === 'application/pdf' && documentDataPreview.dokPages">
                      <div class="content">
                        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 12px; padding: 8px;">
                          <ng-container *ngFor="let pageNum of generatePageNumbers(documentDataPreview.dokPages)">
                            <div class="page-card"
                                 [class.report-doc-arranger-page-selected]="selectedItem.selectedPages && selectedItem.selectedPages.includes(pageNum)"
                                 style="position: relative; border: 2px solid #e0e0e0; border-radius: 8px; overflow: hidden; cursor: pointer; transition: all 0.2s ease; background: white;"
                                 (click)="togglePageSelection(pageNum)">

                              <div style="position: absolute; top: 8px; left: 8px; z-index: 10; background: rgba(255, 255, 255, 0.9); border-radius: 4px; padding: 2px;">
                                <input type="checkbox"
                                       [checked]="selectedItem.selectedPages && selectedItem.selectedPages.includes(pageNum)"
                                       (change)="onPageSelectionChange(pageNum, $event)"
                                       (click)="$event.stopPropagation()"
                                       style="transform: scale(1.2);">
                              </div>

                              <div style="width: 100%; height: 240px; background: #f8f9fa; display: flex; align-items: center; justify-content: center; overflow: hidden;">
                                <img [src]="getPdfPagePreviewUrl(pageNum)"

                                     alt="Seite_{{pageNum}}"
                                     style="max-width: 100%; max-height: 100%; object-fit: cover;"
                                     (error)="hideImage($event)"/>
                              </div>

                              <div style="padding: 8px; text-align: center; background: white; font-weight: 500; color: #333; border-top: 1px solid #f0f0f0;">
                                <ng-container [ngSwitch]="true">
                                  <span *ngSwitchCase="!!selectedItem?.cvID">{{getRessource('Sheet')}} {{pageNum}}</span>
                                  <span *ngSwitchDefault>{{getRessource('Page')}} {{pageNum}}</span>
                                </ng-container>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>

                    <!-- photo doc image preview -->
                    <ng-container *ngIf="!isLoadingPreview && isPhotoDocPreview && documentDataPreview.dokPages">
                      <div class="content">
                        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 12px; padding: 8px;">
                          <ng-container *ngFor="let pageNum of generatePageNumbers(documentDataPreview.dokPages)">
                            <div class="page-card"
                                 [class.report-doc-arranger-page-selected]="selectedItem.selectedPages && selectedItem.selectedPages.includes(pageNum)"
                                 style="position: relative; border: 2px solid #e0e0e0; border-radius: 8px; overflow: hidden; cursor: pointer;transition: all 0.2s ease;background: white;"
                                 (click)="togglePageSelection(pageNum)">

                              <div style="position: absolute; top: 8px; left: 8px; z-index: 10; background: rgba(255, 255, 255, 0.9); border-radius: 4px; padding: 2px;">
                                <input type="checkbox"
                                       [checked]="selectedItem.selectedPages && selectedItem.selectedPages.includes(pageNum)"
                                       (change)="onPageSelectionChange(pageNum, $event)"
                                       (click)="$event.stopPropagation()"
                                       style="transform: scale(1.2);">
                              </div>
                              <!-- todo ngif statt cache für allepreview -->
                              <div style="width: 100%; height: 240px; background: #f8f9fa; display: flex; align-items: center; justify-content: center; overflow: hidden; padding: 2px;">
                                <ng-container *ngIf="photoDocPagesPreview[pageNum - 1]?.images?.length > 0; else noPreview">
                                  <div style="width: 100%; height: 100%; display: grid; gap: 1px; grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));">
                                    <div *ngFor="let image of photoDocPagesPreview[pageNum - 1].images"
                                         style="overflow: hidden; display: flex; align-items: center; justify-content: center; background: #fff;">

                                      <img [src]="getPhotoDocPagePreviewUrl(image)"
                                           [alt]="'Seite_' + pageNum"
                                           style="width: 100%; height: 100%; object-fit: contain;"
                                           (error)="hideImage($event)"/>
                                    </div>

                                  </div>
                                </ng-container>
                                <ng-template #noPreview>
                                  <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; background-color: #f5f5f5; border: 1px dashed #ccc;">
                                    <i class="fa-regular fa-image" style="font-size: 32px; color: #999;"></i>
                                  </div>
                                </ng-template>
                              </div>

                              <div style="padding: 8px; text-align: center; background: white; font-weight: 500; color: #333; border-top: 1px solid #f0f0f0;">
                                <ng-container [ngSwitch]="true">
                                  <span *ngSwitchCase="!!selectedItem?.cvID">{{getRessource('Sheet')}} {{pageNum}}</span>
                                  <span *ngSwitchDefault>{{getRessource('Page')}} {{pageNum}}</span>
                                </ng-container>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                    <!-- calculation preview -->
                    <ng-container *ngIf="!isLoadingPreview && !isPhotoDocPreview && selectedItem.cvID && documentDataPreview.dokPages">
                      <div class="content">
                        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 12px; padding: 8px;">
                          <ng-container *ngFor="let pageNum of generatePageNumbers(documentDataPreview.dokPages)">
                            <div class="page-card"
                                 [class.report-doc-arranger-page-selected]="selectedItem.selectedPages && selectedItem.selectedPages.includes(pageNum)"
                                 style="position: relative; border: 2px solid #e0e0e0; border-radius: 8px; overflow: hidden; cursor: pointer; transition: all 0.2s ease; background: white;"
                                 (click)="togglePageSelection(pageNum)">

                              <div style="position: absolute; top: 8px; left: 8px; z-index: 10; background: rgba(255, 255, 255, 0.9); border-radius: 4px; padding: 2px;">
                                <input type="checkbox"
                                       [checked]="selectedItem.selectedPages && selectedItem.selectedPages.includes(pageNum)"
                                       (change)="onPageSelectionChange(pageNum, $event)"
                                       (click)="$event.stopPropagation()"
                                       style="transform: scale(1.2);">
                              </div>

                              <div style="width: 100%; height: 240px; background: #f8f9fa; display: flex; align-items: center; justify-content: center; overflow: hidden;">
                                <img [src]="getCalculationPagePreviewUrl(pageNum)"
                                     alt="Seite_{{pageNum}}"
                                     style="max-width: 100%; max-height: 100%; object-fit: cover;"
                                     (error)="hideImage($event)"/>
                              </div>

                              <div style="padding: 8px; text-align: center; background: white; font-weight: 500; color: #333; border-top: 1px solid #f0f0f0;">
                                <ng-container [ngSwitch]="true">
                                  <span *ngSwitchCase="!!selectedItem?.cvID">{{getRessource('Sheet')}} {{pageNum}}</span>
                                  <span *ngSwitchDefault>{{getRessource('Page')}} {{pageNum}}</span>
                                </ng-container>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>


                    <div class="splash loading" *ngIf="isLoadingPreview">
                      <div class="spinner"><div></div><div></div><div></div><div></div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ghost -->
            <div class="content" *ngIf="!selectedItem || getAvailablePages(selectedItem) === 1">
              <div style="display: flex; align-items: center; justify-content: center; height: 200px; color: #666;">
                <span *ngIf="!selectedItem">select trans</span>
                <span *ngIf="selectedItem && getAvailablePages(selectedItem) === 1"></span>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noPages>
          <div class="content">
            <div class="splash empty">
              <p>{{getRessource('SelectMultiplePageDoc')}}</p>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!!!arrangementArray?.length">
    <div class="content">
      <div class="splash empty">
        <p>{{getRessource('DataGhost')}}</p>
      </div>
    </div>
  </ng-container>
</div>
